import { jsx as _jsx } from "react/jsx-runtime";
/* Generated file. Do not modify. */
import { createElement } from 'react';
import { IconSvg } from '../../icons/IconSvg.js';
export const SocialMessengerIcon = (props) => createElement(IconSvg, {
    ...props,
    viewBox: "0 0 24 24"
}, _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 11.7492C3 6.90724 7.25467 3 12.5 3C17.7453 3 22 6.90724 22 11.7078C22 16.5514 17.7453 20.457 12.5 20.457C11.5916 20.457 10.7236 20.3759 9.85717 20.1327L6.30435 21.9639V18.3826C4.19718 16.7135 3 14.3132 3 11.7492ZM11.0541 12.1147L13.4501 14.639L18.3243 9.4299L13.9873 11.8302L11.5494 9.4299L6.59288 14.5977L11.0541 12.1147Z", fill: "currentColor" }));
//# sourceMappingURL=SocialMessengerIcon.js.map